module.exports = __webpack_public_path__ + "img/banner3.ca952e57.jpg";